/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_3_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspect the browser’s download list and any blocked-download notice. Keep the workbook open while checking.`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查浏览器下载列表及拦截下载的提示，检查期间保持工作簿打开。`)
};

/**
* | output |
* | --- |
* | "Inspect the browser’s download list and any blocked-download notice. Keep the workbook open while checking." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_3_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_rows_3_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_3_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_3_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_rows_3_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_rows_3_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_rows_3_1 as "gc.search_guides.gridcraft_online.sections.3.table.rows.3.1" }